import { render, staticRenderFns } from "./video-player.vue?vue&type=template&id=04bc9b34"
import script from "./video-player.vue?vue&type=script&lang=js"
export * from "./video-player.vue?vue&type=script&lang=js"
import style0 from "./video-player.vue?vue&type=style&index=0&id=04bc9b34&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports